import styled from "styled-components"

interface IEstimateParam {
  label: string
  value: string
}
interface IEstimateParamsTableProps {
  params: IEstimateParam[]
  px: string
  py: string
}

const Table = styled.table<IEstimateParamsTableProps>`
  background-color: ${(props) => props.theme.colors.bodyBackground};
  font-size: clamp(0.75rem, 0.7rem + 0.25vw, 1rem);
  padding: ${(props) => props.px} ${(props) => props.py};
  width: 100%;
`

const Tr = styled.tr`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  row-gap: 0.25rem;
  column-gap: 0.5rem;

  & + & {
    margin-block-start: 1rem;
  }
`

const Cell = styled.td<{ $bold?: boolean }>`
  // padding: 0.5rem 0.25rem;

  ${(props) => props.$bold && `font-weight: 700;`}
`

const ParamsTable = (props: IEstimateParamsTableProps) => {
  const { params } = props
  return (
    <Table {...props}>
      <tbody>
        {params.map((param) => (
          <Tr key={param.label}>
            <Cell>{param.label} :</Cell>
            <Cell $bold>{param.value}</Cell>
          </Tr>
        ))}
      </tbody>
    </Table>
  )
}

export { ParamsTable, type IEstimateParamsTableProps, type IEstimateParam }
